import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.vishvaconnect.com";
const SITE_NAME = "VishvaConnect Technologies LLP";

const getCanonicalUrl = (path) => {
  if (!path || path === "/") {
    return `${SITE_URL}/`;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${SITE_URL}${normalizedPath}`.replace(/\/+$/, "");
};

function SEO({
  title,
  description,
  path = "/",
  type = "website",
  robots = "index, follow, max-image-preview:large",
  schema = null,
}) {
  const canonicalUrl = getCanonicalUrl(path);

  const schemaItems = Array.isArray(schema)
    ? schema
    : schema
      ? [schema]
      : [];

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      <meta name="robots" content={robots} />

      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Structured data */}
      {schemaItems.map((schemaItem, index) => (
        <script
          key={index}
          type="application/ld+json"
        >
          {JSON.stringify(schemaItem)}
        </script>
      ))}
    </Helmet>
  );
}

export default SEO;